// extracted by mini-css-extract-plugin
module.exports = {"billing_details":"billingHistory_billing_details__21NsM","underlined":"billingHistory_underlined__3oNWq","time_badge":"billingHistory_time_badge__2_6bO"};